import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { winnemuccaConfig } from "./data";

export default function WinnemuccaPage() {
  return <CityPageTemplate config={winnemuccaConfig} />;
}